/* Veyra · Lalo 3.0 · 2026-10-13
   1 · Flechas de la galería (y deslizar con el dedo). La galería sigue siendo de
       radios + CSS: aquí solo se marca el radio anterior o siguiente.
   2 · Caja v3: tarjetas de sabor (solo 30 noches). Cambian el precio y la galería
       del sabor, sin navegar (plantillas de vy-galeria-sabores). */
(function () {
  'use strict';

  /* ---------- 1 · galería ---------- */
  function radios(gal) {
    return Array.prototype.filter.call(gal.children, function (n) { return n.classList && n.classList.contains('vy-gal__r'); });
  }
  function indice(rs) {
    for (var i = 0; i < rs.length; i++) if (rs[i].checked) return i;
    return 0;
  }
  function flechas(gal) {
    var rs = radios(gal), i = indice(rs);
    var ant = gal.querySelector('[data-vy-gal-fl="-1"]'), sig = gal.querySelector('[data-vy-gal-fl="1"]');
    if (ant) ant.hidden = rs.length < 2 || i <= 0;
    if (sig) sig.hidden = rs.length < 2 || i >= rs.length - 1;
  }
  function mover(gal, d) {
    var rs = radios(gal), i = indice(rs) + d;
    if (i < 0 || i >= rs.length) return;
    rs[i].checked = true;
    var img = gal.querySelectorAll('.vy-gal__foto')[i];
    img = img && img.querySelector('img');
    if (img) img.setAttribute('loading', 'eager');
    flechas(gal);
  }
  function todas() { Array.prototype.forEach.call(document.querySelectorAll('.vy-gal'), flechas); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vy-gal-fl]');
    if (!b) return;
    e.preventDefault();
    mover(b.closest('.vy-gal'), +b.getAttribute('data-vy-gal-fl'));
  });
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (r && r.classList && r.classList.contains('vy-gal__r')) flechas(r.closest('.vy-gal'));
  });

  /* deslizar: horizontal de más de 40 px y más horizontal que vertical */
  var x0 = null, y0 = 0;
  document.addEventListener('touchstart', function (e) {
    var m = e.target.closest && e.target.closest('.vy-gal__marco');
    if (!m || e.touches.length !== 1) { x0 = null; return; }
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var m = e.target.closest && e.target.closest('.vy-gal__marco');
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (!m || Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    mover(m.closest('.vy-gal'), dx < 0 ? 1 : -1);
  }, { passive: true });

  /* ---------- 2 · caja v3 ---------- */
  function plantilla(raiz, sabor) {
    var ts = raiz.querySelectorAll('template[data-vy-gal-sabor]');
    for (var i = 0; i < ts.length; i++) if (ts[i].getAttribute('data-vy-gal-sabor') === sabor) return ts[i];
    return null;
  }
  function cambiarGaleria(raiz, sabor) {
    var col = raiz.querySelector('[data-vy-gal-col]'), t = plantilla(raiz, sabor);
    if (!col || !t) return;
    var primera = null;
    Array.prototype.slice.call(col.children).forEach(function (h) {
      if (h.tagName === 'TEMPLATE') { primera = primera || h; } else { col.removeChild(h); }
    });
    var copia = t.content.cloneNode(true);
    var r = copia.querySelector('.vy-gal__r[checked]');
    var img = r ? copia.querySelector('.vy-gal__foto[data-g="' + r.id.split('-').pop() + '"] img') : copia.querySelector('img');
    if (img) img.setAttribute('loading', 'eager');
    col.insertBefore(copia, primera);
    Array.prototype.forEach.call(col.querySelectorAll('.vy-gal'), flechas);
  }
  function urlDeVariante(id) {
    if (location.pathname.indexOf('/products/') !== 0 || !window.history || !history.replaceState) return;
    try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (err) {}
  }

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.classList || !r.classList.contains('vy-s3__r')) return;
    var caja = r.closest('[data-vy-caja3]'), raiz = r.closest('.vy-producto');
    Array.prototype.forEach.call(caja.querySelectorAll('.vy-s3'), function (l) {
      l.classList.toggle('vy-s3--on', l.contains(r));
    });
    if (raiz) {
      var p = raiz.querySelector('[data-vy3-precio]');
      if (p && r.getAttribute('data-precio')) p.textContent = r.getAttribute('data-precio');
      cambiarGaleria(raiz, r.getAttribute('data-sabor'));
    }
    var cta = caja.querySelector('button[type="submit"]');
    if (cta) cta.disabled = r.disabled;
    urlDeVariante(r.value);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
})();

/* LALO 3.0 · barra fija en la ficha = «Agregar al carrito» de verdad: manda el
   formulario de la caja (sabor elegido). veyra-carrito.js lo intercepta y abre el cajón. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-vy-fija-agregar]');
  if (!a) return;
  var f = document.getElementById('vy-form-pdp');
  if (!f) return;
  e.preventDefault();
  if (f.requestSubmit) f.requestSubmit(); else f.querySelector('[type="submit"]').click();
});

/* LALO 3.0 · upsell del carrito: sabor de la 2.ª bolsa. Cambia la variante que manda
   «+ Agregar 2.ª bolsa» (mismo sabor = 2 meses; el otro = bundle 1 Cacao + 1 Vanilla)
   y la foto de la segunda bolsa. Delegado: el cajón se repinta entero. */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-vy-sube3-sabor]');
  if (!b) return;
  var caja = b.closest('.vy-sube3');
  Array.prototype.forEach.call(caja.querySelectorAll('[data-vy-sube3-sabor]'), function (x) {
    x.setAttribute('aria-checked', x === b ? 'true' : 'false');
  });
  caja.querySelector('[data-vy-subir]').setAttribute('data-vy-var', b.getAttribute('data-var'));
  var img = caja.querySelector('[data-vy-sube3-img]');
  if (img) img.src = b.getAttribute('data-img');
});

/* LALO 3.0 · reseñas propias (sections/vy-resenas): «Ver más» descubre N más. */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-vy-resenas-mas]');
  if (!b) return;
  var ocultas = b.closest('[data-vy-resenas]').querySelectorAll('.vy-opiniones__card[hidden]');
  var n = +b.getAttribute('data-paso') || 6;
  for (var i = 0; i < ocultas.length && i < n; i++) ocultas[i].hidden = false;
  if (ocultas.length <= n) b.hidden = true;
});
